import React,{ useState, useEffect } from 'react';
import styles from './Main.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules'; 
import { useSelector } from 'react-redux';

import common from '../../common';
import axios from 'axios';

import Cookies from 'js-cookie';
import Draggable from 'react-draggable';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Main() {
    const { useAlert,useConfirm, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pConfirm, ConfirmComponent} = useConfirm();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();

    const [sliderPack, setSliderPack] = useState([]);
    const [eventPack, setEventPack] = useState([]);
    const [eventBoardPack, setEventBoardPack] = useState([]);
    const [noticePack, setNoticePack] = useState([]);
    const [communityPack, setCommunityPack] = useState([]);
    const [recentEventPack, setRecentEventPack] = useState([]);
    const [memberNewsPack, setMemberNewsPack] = useState([]);
    const [popupPack, setPopupPack] = useState([]);
    const [visiblePopups, setVisiblePopups] = useState([]);



    const member_idx = useSelector((state) => state.user.loginInfo || null);
    const handleLinkClick = (e) => {
        if (!member_idx || (typeof member_idx === 'object' && Object.keys(member_idx).length === 0)) {
            e.preventDefault(); // 링크 이동을 막음
            pAlert('로그인 상태에서 이용하실 수 있습니다.');
            return false;
        }
    };


    const mainRenderData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_main/out/get_render_data`, {}, {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const sortedSlideData = response.data.data_pack.slider_pack.sort((a, b) => a.seq - b.seq);
                setSliderPack(sortedSlideData);
                setEventPack(response.data.data_pack.event_pack);
                setEventBoardPack(response.data.data_pack.eventBoard_pack);
                setNoticePack(response.data.data_pack.notice_pack);
                setCommunityPack(response.data.data_pack.community_pack);
                setRecentEventPack(response.data.data_pack.recent_event_pack);
                setMemberNewsPack(response.data.data_pack.member_news_pack);
                setPopupPack(response.data.data_pack.popup);

                const popupData = response.data.data_pack.popup;
                const initialPopups = popupData.map((popup) => {
                    const cookieName = `hidePopup_${popup.idx}`;
                    const hidePopup = Cookies.get(cookieName);
                    return hidePopup ? false : true; // 쿠키가 있으면 false, 없으면 true
                });
    
                setPopupPack(popupData); // 팝업 데이터를 설정
                setVisiblePopups(initialPopups); // 쿠키 확인 후 보이는 팝업 설정

            } else {
                pAlert(response.data.msg);;
            }
        } catch (error) {
            console.error('Fetch failed:', error);
            pAlert('실패함.');
        } finally {
            pLoadingOff();
        }
    };

    useEffect(() => {
        mainRenderData();
    }, []);

    const closePopup = (index) => {
        setVisiblePopups(prevState => {
            const newState = [...prevState];
            newState[index] = false; // 해당 index의 팝업을 false로 설정해 숨김
            return newState;
        });
    };

    // js-cookie의 주요 사용법
    // 쿠키 설정: Cookies.set('쿠키이름', '값', { expires: 날짜 })
    // 쿠키 가져오기: Cookies.get('쿠키이름')
    // 쿠키 삭제: Cookies.remove('쿠키이름')

    const handleHidePopup = (index, popupIdx) => {
        const tomorrow = new Date();
        tomorrow.setHours(tomorrow.getHours() + 24);
        // tomorrow.setMinutes(tomorrow.getMinutes() + 1); // 테스트 1분 추가

        Cookies.set(`hidePopup_${popupIdx}`, 'true', { expires: tomorrow });
        closePopup(index);
    };




    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1024);
    const [isMobileView2, setIsMobileView2] = useState(window.innerWidth <= 768);

    const handleResize = () => {
        setIsMobileView(window.innerWidth <= 1024);
        setIsMobileView2(window.innerWidth <= 768);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <AlertComponent />
            <LoadingComponent />
            <ConfirmComponent />

            {popupPack.map((popup, index) => (
                visiblePopups[index] && (
                    <Draggable
                        key={popup.idx}
                        handle=".popup_title"
                        defaultPosition={
                            isMobileView2
                                ? { x: 0, y: 0 }  // 모바일 뷰일 때
                                : { x: 120 + index * 40, y: 50 + index * 40 } // 기본 뷰일 때
                        }
                    >
                        <div
                            className={styles.popup_wrap}
                            style={{
                                width: isMobileView2 ? '90%' : 'auto',
                                left: isMobileView2 ? '0' : 'unset',
                                right: isMobileView2 ? '0' : 'unset',
                                top: isMobileView2 ? '10%' : 'unset',
                                margin: isMobileView2 ? '0 auto' : 'auto'
                            }}
                        >
                            <div className={`${styles.popup_title} popup_title`}>
                                <span>{popup.title}</span>
                            </div>
                            <div
                                className={styles.popup_contents_box}
                                style={{ cursor: popup.link ? 'pointer' : 'auto' }}
                                onClick={() => {
                                    if (popup.link) {
                                        window.open(popup.link, '_self');
                                    }
                                }}
                            >
                                <div dangerouslySetInnerHTML={{ __html: popup.contents }} />
                            </div>
                            <div className={styles.popup_bottom_box}>
                                <div className={styles.popup_day_close_box}>
                                    <label className="p_chkbox">
                                        <input
                                            type="checkbox"
                                            onClick={() => handleHidePopup(index, popup.idx)} // 쿠키 설정 및 팝업 닫기 처리
                                        />
                                        <span>오늘 하루 열지 않기</span>
                                    </label>
                                </div>
                                <div className={styles.popup_close_box} onClick={() => closePopup(index)}>
                                    닫기
                                </div>
                            </div>
                        </div>
                    </Draggable>
                )
            ))}












            <div className={styles.main_swiper_wrap}>
                <Swiper
                    modules={[Navigation, Pagination]}
                    navigation
                    pagination={{ clickable: true }}
                    spaceBetween={0}
                    slidesPerView={1}
                    loop={true} 
                    className={styles.swiper_container}
                    >
                    {sliderPack.map((slide, index) => (
                        <SwiperSlide
                            key={slide.idx}
                            style={{
                                backgroundImage: `url(${slide.thumbnailPath})`,
                                cursor: slide.buttonUrl ? 'pointer' : 'default' 
                            }}
                            onClick={() => {
                                if (slide.buttonUrl) { 
                                    window.open(slide.buttonUrl, '_blank');
                                }
                            }}
                        >
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className={styles.components_wrap}>
                {/* sec1 */}
                <div className={styles.main_section_1}>
                    <div className={styles.sec1_left_box}>
                        {/* <div className={styles.sec1_btn_box}>
                            <a href="/event" className={`${styles.m_s1_l_btn} ${styles.sec1_left_event_btn}`}>행사신청</a>
                            <span>행사신청</span>
                        </div>
                        <div className={styles.sec1_btn_box}>
                            <a href="/membersSearch" className={`${styles.m_s1_l_btn} ${styles.sec1_left_member_btn}`} onClick={handleLinkClick}>회원검색</a>
                            <span>회원검색</span>
                        </div>
                        <div className={styles.sec1_btn_box}>
                            <a href="/notice" className={`${styles.m_s1_l_btn} ${styles.sec1_left_notice_btn}`}>공지사항</a>
                            <span>공지사항</span>
                        </div>
                        <div className={styles.sec1_btn_box}>
                            <a href="/community" className={`${styles.m_s1_l_btn} ${styles.sec1_left_community_btn}`}>커뮤니티</a>
                            <span>커뮤니티</span>
                        </div> */}

                        <div className={styles.pub_main_box}>
                            <span className={styles.pub_main_title}>행사 캘린더</span>
                            <a href="/eventBoard" className={styles.pub_main_more}><span>더보기</span></a>
                        </div>
                        <div className={styles.sec1_right_content_box}>
                            {/* {eventBoardPack.map((event) => (
                                <a href={`/noticedetail?id=${event.idx}&type=document`} key={event.idx} className={styles.eventBoard_btn}>
                                    <span className={styles.sec1_right_content_title} style={{ display: 'none' }}>{event.title}</span>
                                    <span className={styles.sec1_right_date} style={{ display: 'none' }}>{event.createTime}</span>
                                </a>
                            ))} */}
                            {eventBoardPack?.[0] && (
                            <a
                                href={`/noticedetail?id=${eventBoardPack[0].idx}&type=document`}
                                key={eventBoardPack[0].idx}
                                className={styles.eventBoard_btn}
                            >
                                <img
                                src={eventBoardPack[0].thumbnail || "/img/logo2.png"}
                                alt={eventBoardPack[0].title || "No title available"}
                                />
                            </a>
                            )}




















                        </div>
                    </div>
                    <div className={styles.sec1_right_box}>
                        <div className={styles.pub_main_box}>
                            <span className={styles.pub_main_title}>모집중인 행사</span>
                            <a href="/event" className={styles.pub_main_more}><span>더보기</span></a>
                        </div>
                        <div className={styles.sec1_right_content_box}>
                            {eventPack.map((event) => (
                                <a href={`/noticedetail?id=${event.idx}&type=Event`} key={event.idx} className={styles.sec1_right_content_btn}>
                                    <span className={styles.sec1_d_day}>{event.dDay}</span>
                                    <span className={styles.sec1_right_content_title}>
                                        [{event.cate}] {event.title}
                                    </span>
                                    <span className={styles.sec1_right_date}>
                                        {event.date}
                                    </span>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
                
            </div>
            {/* sec1 끝 */}
            {/* sec2 */}
            <div className={styles.main_full_component_wrap}>
                <div className={styles.main_section_2}>
                    <div className={styles.sec2_left_box}>
                        <div className={styles.pub_main_box}>
                            <span className={styles.pub_main_title}>공지사항</span>
                            <a href="/notice" className={styles.pub_main_more}><span>더보기</span></a>
                        </div>
                        <div className={styles.sec2_main_table_box}>
                            {noticePack.map((notice) => (
                                <a href={`/noticedetail?id=${notice.idx}&type=document`} key={notice.idx} className={styles.sec2_main_table_btn}>
                                    <span className={styles.sec2_main_table_title}>{notice.title}</span>
                                    <span className={styles.sec2_main_table_date}>{notice.createTime}</span>
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className={styles.sec2_right_box}>
                        <div className={styles.pub_main_box}>
                            <span className={styles.pub_main_title}>최근게시물</span>
                            <a href="/community" className={styles.pub_main_more}><span>더보기</span></a>
                        </div>
                        <div className={styles.sec2_main_table_box}>
                            {communityPack.map((item) => (
                                <a href={`/noticedetail?id=${item.idx}&type=document`} key={item.idx} className={styles.sec2_main_table_btn}>
                                    <span className={styles.sec2_main_table_title}>
                                        [{item.categoryName}] {item.title}
                                    </span>
                                    <span className={styles.sec2_main_table_date}>
                                        {item.createTime}
                                    </span>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {/* sec2 끝 */}
            {/* sec3 */}
            <div className={styles.components_wrap}>
                <div className={styles.main_section_3}>
                    <div className={styles.sec3_left_box}>
                        <div className={styles.pub_main_box}>
                            <span className={styles.pub_main_title}>최근동향</span>
                            <a href="/" className={styles.pub_main_more}><span>더보기</span></a>
                        </div>
                        <div className={styles.sec3_left_content_box}>
                            {recentEventPack.map((event) => (
                                <a href={`/noticedetail?id=${event.idx}&type=Event`} key={event.idx} className={styles.sec3_left_content_btn}>
                                    <div className={styles.txtBg}></div>
                                    <div className={styles.txtBox}>
                                        <span className={styles.sec3_left_content_title}>{event.title}</span>
                                        <span className={styles.sec3_left_content_date}>{event.createTime}</span>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className={styles.sec3_right_box}>
                        <div className={styles.pub_main_box}>
                            <span className={styles.pub_main_title}>회원동정</span>
                            <a href="/membersNews" className={styles.pub_main_more}><span>더보기</span></a>
                        </div>
                        <div className={styles.sec3_right_content_box}>
                            {memberNewsPack.length > 0 && (
                                <a 
                                    href={`/noticedetail?id=${memberNewsPack[0].idx}&type=document`}
                                    className={styles.sec3_right_main_btn}
                                    style={{ 
                                        backgroundImage: `url(${memberNewsPack[0].thumbnail || '/img/logo2.png'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center' 
                                    }}
                                    >
                                    <div className={styles.sec3_right_main_bg}>
                                        <span>{memberNewsPack[0].title}</span>
                                    </div>
                                </a>
                            )}
                            <div className={styles.sec3_sub_box}>
                                {memberNewsPack.length > 1 && (
                                    <a 
                                        href={`/noticedetail?id=${memberNewsPack[1].idx}&type=document`}
                                        className={styles.sec3_right_sub_btn_1}
                                        style={{ 
                                            backgroundImage: `url(${memberNewsPack[1].thumbnail || '/img/logo2.png'})`,
                                            backgroundSize: 'cover', 
                                            backgroundPosition: 'center' 
                                        }}
                                        >
                                        <div className={styles.sec3_right_sub_bg_1}></div>
                                        <span>{memberNewsPack[1].title}</span>
                                    </a>
                                )}
                                {memberNewsPack.length > 2 && (
                                    <a 
                                        href={`/noticedetail?id=${memberNewsPack[2].idx}&type=document`}
                                        className={styles.sec3_right_sub_btn_2}
                                        style={{ 
                                            backgroundImage: `url(${memberNewsPack[2].thumbnail || '/img/logo2.png'})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center' 
                                        }}
                                        >
                                        <div className={styles.sec3_right_sub_bg_2}></div>
                                        <span>{memberNewsPack[2].title}</span>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* sec3 끝 */}
        </>
    );
}

export default Main;
